import { type Editor } from '@tiptap/react';
import { type TableOfContentData } from '@tiptap/extension-table-of-contents';
import { FloatingPortal, type useInteractions } from '@floating-ui/react';
import { type CSSProperties, type RefCallback } from 'react';

import { Arrow } from '@flintmint/web-shared/components/arrow';
import { TableOfContents } from '@/components/table-of-contents';

import styles from './toc-rail.module.scss';

type GetFloatingProps = ReturnType<typeof useInteractions>['getFloatingProps'];

export const ToCRailPanel = (props: ToCRailPanelProps) => {
  const { editor, headings, isMounted, floatingStyles, transitionStyles, getFloatingProps, setFloatingNode, arrowStyle, side } =
    props;

  if (!isMounted) {
    return null;
  }

  return (
    <FloatingPortal>
      <div
        {...getFloatingProps({
          style: floatingStyles,
          className: styles.tocPopoverPosition,
        })}
        ref={setFloatingNode}
        data-testid="toc-popover"
      >
        <div className={styles.tocPopover} style={transitionStyles}>
          <Arrow
            data-arrow
            style={arrowStyle}
            attributes={{
              'data-popper-placement': side,
            }}
          />
          <div className={styles.tocPopoverBody}>
            <TableOfContents editor={editor} content={headings} />
          </div>
        </div>
      </div>
    </FloatingPortal>
  );
};

interface ToCRailPanelProps {
  editor: Editor | null;
  headings: TableOfContentData;
  isMounted: boolean;
  floatingStyles: CSSProperties;
  transitionStyles: CSSProperties;
  getFloatingProps: GetFloatingProps;
  setFloatingNode: RefCallback<HTMLElement>;
  arrowStyle: CSSProperties;
  side: string;
}
